export const countryChoices = async (client) => {
    return await client.get('form/choice/country');
};
